import { USAStates } from "./usaStates";
const defaultStateLaws = {
    maxConsentExpiryMonths: null,
    requiresSensistiveDataConfirmation: false,
    ageOfConsent: 18,
};
const stateLaws = {
    [USAStates.AL]: { ageOfConsent: 19 },
    [USAStates.OR]: { requiresSensistiveDataConfirmation: true },
    [USAStates.TX]: { requiresSensistiveDataConfirmation: true },
    [USAStates.MA]: { requiresSensistiveDataConfirmation: true },
    [USAStates.ME]: { maxConsentExpiryMonths: 30 },
    [USAStates.MT]: { maxConsentExpiryMonths: 30 },
    [USAStates.MD]: { maxConsentExpiryMonths: 12 },
    [USAStates.WY]: { maxConsentExpiryMonths: 12 },
    [USAStates.IL]: { maxConsentExpiryMonths: 12 },
};
export class StateLawsService {
    getStateLaws(state) {
        return { ...defaultStateLaws, ...stateLaws[state] };
    }
    getMaxConsentExpiryMonths(state) {
        return this.getStateLaws(state).maxConsentExpiryMonths;
    }
    getAgeOfConsent(state) {
        return this.getStateLaws(state).ageOfConsent;
    }
    isUnderage(state, age) {
        return age < this.getAgeOfConsent(state);
    }
    requiresSensistiveDataConfirmation(state) {
        if (state === null) {
            return false;
        }
        return this.getStateLaws(state).requiresSensistiveDataConfirmation;
    }
}
